<script lang="ts" xmlns:svelte="http://www.w3.org/1999/html">
    import MainLayout from '../../#common/layout/Layout.svelte'
    import {Link} from 'svelte-routing'
    import {createRole} from 'src/components/cabinet/#services/adminRoles'
    import {doShow as showAlert} from 'src/components/#common/alert/store'
    import {navigate} from 'src/components/cabinet/#common/helpers'

    const allPages = [
        "Apps",
        "Analytics",
        "Transactions",
        "Users",
        "Holders",
        "Memberships",
        "Administrators",
        "Nft",
        "Deposit-Wallets",
        "Emails",
        "Blog",
        "Polls",
        "News",
        "Confirmations",
        "Actions",
        "App-configs",
        "Settings",
        "Tasks"
    ]

    let pages = []
    let methods = ''
    let roleName = ''

    const onCheckPages = event => {
        if (event.target.checked) {
            pages.push(event.target.value.toLowerCase());
        } else {
            pages.splice(event.target.value.toLowerCase());
        }
        pages = pages
    };

    async function createNewRoll() {
        try {
            await createRole.request({
                data: {
                    roleName: roleName,
                    methods: methods.split(', '),
                    pages: pages
                }
            })

            showAlert.set({
                status: 'success',
                text: 'Role has been added successfully'
            })

            navigate("/administrators")
        } catch (err) {
            showAlert.set({
                status: 'error',
                text: err.message
            })
        }
    }
</script>

<svelte:head>
    <title>Add new role</title>
</svelte:head>

<MainLayout title="Add new role">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="administrators" class="btn btn-primary mb-3">Back</Link>
                <div class="pages">
                    <div class="form-group mb-3">
                        <label>Role name</label>
                        <input type="text" bind:value={roleName} class="form-control" autofocus>
                    </div>
                    <div class="form-group mb-3">
                        <label>Allowed pages</label>
                        {#each allPages as page}
                            <div class="form-check mb-1">
                                <input class="form-check-input" type="checkbox" value={page} id={page}
                                    checked={pages.includes(page)} on:change={onCheckPages}>
                                <label class="form-check-label" for={page}>{page}</label>
                            </div>
                        {/each}
                    </div>
                    <div class="form-group mb-3">
                        <label>Allowed methods</label>
                        <textarea class="form-control" bind:value={methods} placeholder="ban, setMembership, ..."></textarea>
                    </div>
                    <button type="submit" class="btn btn-success" on:click={createNewRoll}>Create</button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-body roles-list">
                <h5><strong>Methods</strong></h5>
                <hr>
                <p><strong>ban</strong> - ability to ban/unban the user</p>
                <p><strong>updateBalance</strong> - increase and decrease <span class="notranslate">LIS</span> to the balance</p>
                <p><strong>addSolutionAdmin</strong> - confirming the actions of other administrators</p>
                <p><strong>changeMembershipGame</strong> - ability to change game for user membership</p>
                <p><strong>cancelActions</strong> - canceling the actions of administrators</p>
                <p><strong>deleteMembership</strong> - deletion of user membership</p>
                <p><strong>setMembership</strong> - ability to give membership to users</p>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    select {
        width: auto;
        margin: 0 auto;
    }

    .administrators-list :global(td) {
        text-align: center;
        vertical-align: middle;
    }

    .form-control {
        max-width: 350px;
    }

    .form-check-input,
    .form-check-label {
        cursor: pointer;
    }
</style>
